export const API_URL = 'https://billing.pnsinfotech.com/rest/';
export const IMAGE_PATH = 'https://billing.pnsinfotech.com/rest/uploads';
export const MAX_RESULTS = 10;

export const LOGOUT_TIME = 1000 * 60 * 24; //replace last value with how many minutes

export const EXCLUDE_URL = [
    "partner/login"
]

export const PRODUCT_STATUS = {
    1: {
        name: "active", colorClass: "text-success"
    },
    2: {
        name: "deactive", colorClass: "text-danger"
    }
}

export const ORDER_STATUS = {
    1: {
        name: "processing", colorClass: "text-info"
    },
    2: {
        name: "complete", colorClass: "text-success"
    },
    3: {
        name: "rejected", colorClass: "text-danger"
    }
}

export const CUSTOMER_STATUS = {
    1: {
        name: "active", colorClass: "text-success"
    },
    2: {
        name: "deactive", colorClass: "text-danger"
    }
}

export const PAYMENT_STATUS = {
    1: {
        name: "paid", colorClass: "text-success"
    },
    2: {
        name: "not_paid", colorClass: "text-danger"
    },
    3: {
        name: "partial_paid", colorClass: "text-info"
    }
}

export const GST_TYPES = {
    1: "Registered - Regular GST",
    2: "Registered - Camp Scheme",
    3: "Unregistered Business",
    4: "Consumer B2C",
    5: "Overseas (Outside India)",
    6: "Special Economic Zone",
    7: "Deemed Export"
}

export const PAYMENT_MODE = {
    1: "CASH",
    2: "UPI",
    3: "NET BANKING",
    4: "CREDIT CARD",
    5: "DEBIT CARD",
    6: "CHEQUE",
    7: "CREDIT NOTE",
    8: "OTHER"
}

export const PAYMENT_TYPES = {
    1: "PAYMENT RECEIVED",
    2: "PAYMENT MADE"
}

export const VENDOR_ITEMS = {
    1: "Adjustment on purchase",
    2: "Adjustment on sales",
    3: "Advertising & Marketing",
    4: "Automobile expense",
    5: "Bonus",
    6: "Credit card charges",
    7: "Gain or loss on fluctuation in foreign currency",
    8: "IT & Internet expense",
    9: "Meals & Entertainment",
    10: "Medical Expenses",
    11: "Office supplies",
    12: "Operational",
    13: "Payment gateway charge",
    14: "Payroll",
    15: "Petrol Expenses",
    16: "Printing & Stationery",
    17: "Rent",
    18: "Repairs & Maintenance",
    19: "Shipping charge",
    20: "Team building",
    21: "Telephone expense",
    22: "Travel expense",
    23: "Utilities"
}

export const HOT_KEYS = [
    { key: 'alt+d', route: '/root', label: "Dashboard" },
    { key: 'alt+i', route: '/root/invoices', label: "Invoices Master" },
    { key: 'i+n', route: '/root/invoices/new', label: "New Invoice" },
    { key: 'alt+o', route: '/root/po', label: "Purchase Orders" },
    { key: 'o+n', route: '/root/po/new', label: "New Purchase Order" },
    { key: 'alt+c', route: '/root/customer', label: "Customers" },
    { key: 'c+n', route: '/root/customer/add', label: "New Customer" },
    { key: 'alt+v', route: '/root/vendor', label: "Vendors" },
    { key: 'v+n', route: '/root/vendor/add', label: "New Vendor" },
    { key: 'alt+p', route: '/root/product', label: "Products" },
    { key: 'shift+p', route: '/root/payment', label: "Payment" },
    { key: 'p+c', route: '/root/payment/customerPayment', label: "New Customer Payment" },
    { key: 'p+v', route: '/root/payment/vendorPayment', label: "New Vendor Payment" },
    { key: 'alt+e', route: '/root/expense', label: "Expenses" },
    { key: 'e+n', route: '/root/expense/new', label: "New Expense" },
];

export const lableStyle = { position: "absolute", top: "-10px", left: "23px", backgroundColor: "white", paddingLeft: "3px", paddingRight: "3px", zIndex: 1 }

